var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNbLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64.481mm",
    height: "30.014mm",
    viewBox: "0 0 64.481 30.014",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e11d48"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.5527e-15,
    width: 13.345,
    height: 30.014,
    strokeWidth: 0.27004
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.146-8.6248e-6 14.037 30.014h-14.037v-30.014",
    strokeWidth: 0.365
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.523 30.014v-30.014h-8.681v30.014z",
    strokeWidth: 0.51619
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5833 0 0 .68622 -51.434 -102.97)",
    strokeWidth: 1.0089,
    "aria-label": "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.966 150.05h10.372c3.5407 0 5.6539 0.96768 7.2785 2.6339 1.6246 1.6246 2.4368 4.1447 2.4368 7.5604v1.7495c0 2.2494-0.3749 4.0822-1.1247 5.4985-0.70814 1.4163-1.3426 2.3022-2.8422 2.9271v0.12497c3.4157 1.1663 5.1236 4.2072 5.1236 9.1225l2e-6 10.622c1e-6 3.3741 0 3.499-2.5118 3.499-1.9068 0-4.5071-2e-5 -7.9228-2e-5h-10.81zm9.5599 17.808c1.3746 0 2.3952-0.35407 3.0617-1.0622 0.70814-0.70814 1.0622-1.8953 1.0622-3.5615v-2.4368c0-1.5829-0.29159-2.7284-0.87476-3.4366-0.54152-0.70814-1.4163-1.0622-2.6243-1.0622h-3.3116v11.559zm1.2497 19.682c1.208 0 2.1036-0.31241 2.6868-0.93724 0.58317-0.66648 0.87476-1.7912 0.87476-3.3741v-3.8114c0-1.9994-0.35407-3.3741-1.0622-4.1239-0.66648-0.79145-1.7912-1.1872-3.3741-1.1872h-3.0617v13.434z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m11.544 30.014 5.8181-5.1311-2.2164-24.883h-3.6017v30.014",
    strokeWidth: 0.365
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbLogo);
export default __webpack_public_path__ + "static/media/NB_Logo.56b5223a03b64aa89f2e0c4e1134f462.svg";
export { ForwardRef as ReactComponent };